import moment from "moment";

export const getTimestampFormat = (dateString) => {
  return new Date(dateString).getTime() / 1000;
};

export const getCurrenTimestampFormat = () => new Date().getTime() / 1000;

export const getHumanDateOfTimestamp = (formatDate) => {
  return moment(new Date(formatDate).toISOString())
    .locale("es")
    .format("LLL");
};
